<template>
  <a-drawer
    width="45%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="provinceId">
        <span slot="label">
          <a-tooltip>
            Select Country<template slot="title">Select Country</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.provinceId" placeholder="Please select country" @change="handleProvinceIdChange">
          <a-select-option
            v-for="(item, index) in this.templateList"
            :value="item.id"
            :key="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="'Warehouse Processing Time'" prop="warehouseTime">
        <a-form-model-item prop="warehouseTimeStart" style="display: inline-block;">
          <a-input-number v-model="form.warehouseTimeStart" placeholder="Please enter warehouse processing time" />
        </a-form-model-item>
        <span style="text-align: center;"> to </span>
        <a-form-model-item prop="warehouseTimeEnd" style="display: inline-block;">
          <a-input-number v-model="form.warehouseTimeEnd" placeholder="Please enter warehouse processing time" />
        </a-form-model-item>
      </a-form-model-item>
      <a-form-model-item :label="'Delivery Time'" prop="deliveryTime">
        <a-form-model-item prop="deliveryTimeStart" style="display: inline-block;">
          <a-input-number v-model="form.deliveryTimeStart" placeholder="Please enter delivery time" />
        </a-form-model-item>
        <span style="text-align: center;"> to </span>
        <a-form-model-item prop="deliveryTimeEnd" style="display: inline-block;">
          <a-input-number v-model="form.deliveryTimeEnd" placeholder="Please enter delivery time" />
        </a-form-model-item>
      </a-form-model-item>
      <a-form-model-item prop="status">
        <span slot="label">
          <a-tooltip>
            Status<template slot="title">Status</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button :value="1">
            Yes
          </a-radio-button>
          <a-radio-button :value="0">
            No
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            Save
          </a-button>
          <a-button type="dashed" @click="cancel">
            Cancel
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getShippingTimeEffect, addShippingTimeEffect, updateShippingTimeEffect } from '@/api/shipping/shippingTimeEffect'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
import * as logistics from '@/api/logistics'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        provinceId: null,

        province: null,

        warehouseTimeStart: null,

        warehouseTimeEnd: null,

        deliveryTimeStart: null,

        deliveryTimeEnd: null,

        status: 0

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        status: [
          { required: true, message: 'Status: 0-Disabled, 1-Enabled cannot be empty', trigger: 'blur' }
        ]
      },
      templateList: [],
      templateMap: {}
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        provinceId: null,
        province: null,
        warehouseTimeStart: null,
        warehouseTimeEnd: null,
        deliveryTimeStart: null,
        deliveryTimeEnd: null,
        status: 0
      }
    },
    getTemplateList() {
      logistics.shippingTemplatesList({ pageNum: 1, pageSize: 10000 }).then(response => {
        if (!response.success) {
          return
        }
        const records = response.data.records
        const _templateList = []
        const _templateMap = {}
        for (let i = 0; i < records.length; i++) {
          const _record = records[i]
          _templateList.push({ id: _record.id, name: _record.name })
          _templateMap[_record.id] = _record
        }

        this.templateList = _templateList
        this.templateMap = _templateMap
      })
    },
    handleProvinceIdChange(value) {
      console.log('handleProvinceIdChange, value : ', value)
      let _template = this.templateMap[value]
      this.form.province = _template.name;
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = 'Add'
      this.getTemplateList()
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      this.getTemplateList()
      getShippingTimeEffect({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = 'Edit'
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = 'Updated successfully'
            updateShippingTimeEffect(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = 'Added successfully'
            addShippingTimeEffect(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
